import React from 'react';
import Title from '../../../elements/Title';
import List, { ListItem } from '../../../elements/List';
import Link from '../../../components/Link';
import Section from '../../../elements/Section';

export default function ShareholderStructure() {
  return (
    <Section>
      <Title>Shareholders Structure</Title>
      <List>
        <ListItem>Share capital: EUR 13.453.446,00</ListItem>
        <ListItem>
          Number of outstanding shares as of November 22, 2016: 2.318.965
        </ListItem>
        <ListItem>
          Number of voting rights as of November 22, 2016: 2.318.965
        </ListItem>
        <ListItem>Euronext Symbol: MLMFI</ListItem>
        <ListItem>
          Condor Technologies NV listed on Euronext Access - Paris on May 10,
          2013
        </ListItem>
        <ListItem>
          Since May 10, 2013 1.150.000 shares can be transferred through
          Euronext Access- Paris
        </ListItem>
        <ListItem>ISIN Code: BE6252013725</ListItem>
        <ListItem>LEI: 9676003NK54369PYVG89</ListItem>
        <ListItem>
          The most recent share price you can find on the{' '}
          <Link
            href="https://www.euronext.com/products/equities/BE6252013725-XMLI"
            target="_blank">
            official Euronext website
          </Link>
        </ListItem>
        <ListItem>
          Each of the shares carries one voting right at the general meeting of
          shareholders No outstanding options or warrants have been issued that
          entitle their holder to shares, nor shares without voting rights.
        </ListItem>
        <ListItem>
          Currently (April 23th, 2018) there are no shareholders owning more
          than 25% of the share capital or voting rights (Ultimate Beneficial
          Owners).
        </ListItem>
      </List>
    </Section>
  );
}

ShareholderStructure.propTypes = {};
